export enum DeliveryReason {
  INITIAL = 'INITIAL',
  COPY = 'COPY',
  REMINDER = 'REMINDER',
  MANUAL_REMINDER = 'MANUAL_REMINDER',
}
